import Vue from "vue";
import VueRouter from "vue-router";

import HomeView from "@/views/index.vue"
import Strategy from '@/views/strategy.vue'
import Detail from '@/views/detail.vue'
import Pano from '../views/pano.vue'
import Food from '@/views/food.vue'
import Attr from '@/views/attr.vue'
import Cate from '@/views/cate.vue'
import Info from '@/views/info.vue'

import Error404 from '@/views/error-404.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/cate",
    name: "Cate",
    component: Cate,
  },
  {
    path: "/cate/info",
    name: "CateInfo",
    component: Info,
  },
  {
    path: "/strategy",
    name: "Strategy",
    component: Strategy,
  },
  {
    path: "/food",
    name: "Food",
    component: Food,
  },
  {
    path: "/attr",
    name: "Attr",
    component: Attr,
  },
  {
    path: "/detail",
    name: "Detail",
    component: Detail,
  },
  {
    path: "/pano",
    name: "Pano",
    component: Pano,
    menu: false
  },
  {
    path: '/404',
    component: Error404
  },
  { path: '*', redirect: '/404', hidden: true }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
